import { useState, useEffect } from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import ModalNegociacao from '../ModalDetalhesWarmup/ModalDetalhesWarmup';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../Auth/AuthContext/AuthContext";



const ControleProjetosFinanceiro = () => {

    const [dados, setDados] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [showIniciarModal, setShowIniciarModal] = useState(false);
    const [showArquivarModal, setShowArquivarModal] = useState(false);
    const [responsavel, setResponsavel] = useState(null);
    const [currentProjeto, setCurrentProjeto] = useState(null);
    
    const { userData } = useAuth(); 
    const [dadosWarmup, setDadosWarmup] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [negociacaoSelecionada, setNegociacaoSelecionada] = useState(null);
    const [activeMenu, setActiveMenu] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState('');
    const [dateRange, setDateRange] = useState({ start: '', end: '' });
    const [relativeDate, setRelativeDate] = useState('');
    const [etapaFilter, setEtapaFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    const [showVoltarModal, setShowVoltarModal] = useState(false);
    const [observacaoVoltar, setObservacaoVoltar] = useState("");
    const [currentItemVoltar, setCurrentItemVoltar] = useState(null);
    const [showEncerrarModal, setShowEncerrarModal] = useState(false);


    const API_URL = process.env.REACT_APP_API_URL || 'https://sic-conti-backend.vercel.app';

    const limparFiltros = () => {
        setSearchTerm('');
        setDateRange({ start: '', end: '' });
        setRelativeDate('');
        setEtapaFilter('');
        setStatusFilter('');
        setFilteredData(dados);
    };


    async function listarWarmup() {
        try {
            const response = await fetch(`${API_URL}/api/listar_warmup`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
            }

            const data = await response.json();
            setDadosWarmup(data.data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        listarWarmup();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.menu-dropdown')) {
                setActiveMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const filtered = dadosWarmup.filter(item => {
            return (
                (etapaFilter === '' || item.etapa === etapaFilter) &&
                (statusFilter === '' || item.status === statusFilter) &&
                (searchTerm === '' || item.capa_projeto.codigo.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        });
        setFilteredData(filtered);
    }, [etapaFilter, statusFilter, searchTerm, dadosWarmup]);

    const abrirModal = (negociacao) => {
        setNegociacaoSelecionada(negociacao);
        setActiveMenu(null); // Fecha o menu ao abrir o modal
    };

    const fecharModal = () => {
        setNegociacaoSelecionada(null);
    };

    const toggleMenu = (id) => {
        setActiveMenu(activeMenu === id ? null : id);
    };

    const handleAvancarEtapa = (item) => {
        setCurrentItem(item);
        setShowConfirmModal(true);
        setActiveMenu(null); // Fecha o menu ao avançar etapa
    };

    
    const handleVoltarEtapa = (item) => {
        setCurrentItemVoltar(item);
        setShowVoltarModal(true);
        setActiveMenu(null); // Fecha o menu ao abrir o modal
    };

    const confirmarVoltarEtapa = async () => {
        try {
            const usuario = userData?.user?.displayName || "Usuário Anônimo"; // Obtém o nome do usuário
    
            const response = await fetch(`${API_URL}/api/warmup/alterar_etapa/${currentItemVoltar._id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    etapa: 'Warmup Comercial',
                    status: "Revisar",
                    data: new Date().toLocaleString("pt-BR"),
                    observacao: observacaoVoltar,
                    usuario: usuario, // Envia o nome do usuário logado
                }),
            });
    
            if (!response.ok) {
                throw new Error(`Erro ao atualizar etapa: ${response.statusText}`);
            }
    
            listarWarmup();
            alert('Etapa atualizada com sucesso!');
        } catch (error) {
            alert(`Erro ao atualizar etapa: ${error.message}`);
        } finally {
            setShowVoltarModal(false);
            setCurrentItemVoltar(null);
            setObservacaoVoltar("");
        }
    };

    const handleEncerrarProjeto = (item) => {
        setCurrentItem(item);
        setShowConfirmModal(true);
        setActiveMenu(null); // Fecha o menu ao abrir o modal
    };

    const enviarEmailGerenteProjetoEncerrado = async (item) => {
        const emailBody = `
            <p>Olá ${item.capa_projeto.gerente_projeto.nome},</p>
            <p>O projeto <strong>${item.capa_projeto.codigo}</strong> foi encerrado com sucesso dentro do SIC.</p>
            <p>Atenciosamente,<br>Equipe ConTI Consultoria</p>
        `;
    
        try {
            const emailResponse = await fetch(`${API_URL}/api/enviar-email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    sender_email: "warmup@conticonsultoria.com.br",
                    recipient_email: item.capa_projeto.gerente_projeto.email,
                    subject: `Projeto ${item.capa_projeto.codigo} Encerrado com Sucesso`,
                    body_content: emailBody,
                }),
            });
    
            if (!emailResponse.ok) {
                const errorText = await emailResponse.text();
                throw new Error(`Erro ao enviar email: ${emailResponse.status} - ${errorText}`);
            }
            console.log("Email enviado com sucesso!");
        } catch (err) {
            console.error("Erro ao enviar email:", err.message);
        }
    };

    const confirmarEncerrarProjeto = async () => {
        try {
            const response = await fetch(`${API_URL}/api/warmup/alterar_etapa/${currentItem._id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    etapa: 'Projeto Encerrado',
                    status: 'Encerrado' 
                }),
            });

            if (!response.ok) {
                throw new Error(`Erro ao encerrar projeto: ${response.statusText}`);
            }

            listarWarmup();
            alert('Projeto encerrado com sucesso!');
            await enviarEmailGerenteProjetoEncerrado(currentItem);
        } catch (error) {
            alert(`Erro ao encerrar projeto: ${error.message}`);
        } finally {
            setShowConfirmModal(false); // Fecha o modal de confirmação
            setShowEncerrarModal(false); // Fecha o modal de encerramento
            setCurrentItem(null);
        }
    };
        
    const redirecionarFormulario = (id) => {
        navigate(`/forms-warmup-projetos/${id}`);
        setActiveMenu(null); // Fecha o menu ao redirecionar
    };

    return (
        <div className="flex flex-col p-4 min-h-screen w-full px-10">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Controle de Projetos</h1>
            <div className="flex space-x-4 mb-4">
                <input
                    type="text"
                    placeholder="Pesquisar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="border border-gray-300 rounded-md p-2"
                />
                <select
                    value={etapaFilter}
                    onChange={(e) => setEtapaFilter(e.target.value)}
                    className="border border-gray-300 rounded-md p-2"
                >
                    <option value="">Todas as Etapas</option>
                    <option value="Warmup Comercial">Warmup Comercial</option>
                    <option value="Projeto Liberado">Projeto Liberado</option>
                    <option value="Encerramento Financeiro">Encerramento Financeiro</option>
                    <option value="Projeto Encerrado">Projeto Encerrado</option>
                </select>
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="border border-gray-300 rounded-md p-2"
                >
                    <option value="">Todos os Status</option>
                    <option value="Revisar">Revisar</option>
                    <option value="Preenchendo">Preenchendo</option>
                    <option value="Liberado">Liberado</option>
                    <option value="Encerrado">Encerrado</option>
                </select>
                <button
                    onClick={limparFiltros}
                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded shadow hover:bg-gray-400 transition"
                >
                    Limpar Filtros
                </button>
            </div>
            {loading && <p className="text-sm font-medium text-gray-600">Carregando...</p>}
            {error && <p className="text-sm font-medium text-red-500">Erro: {error}</p>}
            {!loading && !error && filteredData.length === 0 && (
                <p className="text-sm font-medium text-gray-600">Nenhum projeto retornado.</p>
            )}
            {!loading && !error && filteredData.length > 0 && (
                <div className="max-w bg-white rounded-lg shadow-md">
                    <table className="table-auto w-full text-sm text-left border-collapse">
                        <thead className="bg-gray-200">
                            <tr>
                                <th className="px-2 py-1 font-semibold text-gray-600">Gerente do Projeto</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Código do Projeto</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Centro de Resultados</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Valor</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Status</th>
                                <th className="px-2 py-1 font-semibold text-gray-600">Etapa</th>
                                <th className="px-2 py-1 text-center font-semibold text-gray-600">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item) => (
                                <tr key={item._id} className="hover:bg-gray-50">
                                    <td className="px-2 py-1 text-gray-700">{item?.capa_projeto?.gerente_projeto?.nome || "N/A"}</td>
                                    <td className="px-2 py-1 text-gray-700">{item?.capa_projeto?.codigo || ""}</td>
                                    <td className="px-2 py-1 text-gray-700">{item?.capa_projeto?.centro_resultado?.NOME || "N/A"}</td>
                                    <td className="px-2 py-1 text-gray-700">
                                        {new Intl.NumberFormat('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                        }).format(item?.formacao_preco?.valor || "")}
                                    </td>
                                    <td className="px-2 py-1">
                                        <span
                                            className={`font-semibold ${(() => {
                                                switch (item.status) {
                                                    case "Revisar":
                                                        return "text-amber-500";
                                                    case "Preenchendo":
                                                        return "text-blue-400";
                                                    case "Liberado":
                                                        return "text-green-400";
                                                    case "Encerrado":
                                                        return "text-red-400";
                                                    default:
                                                        return "text-gray-700";
                                                }
                                            })()}`}
                                        >
                                            {item.status || "N/A"}
                                        </span>
                                    </td>
                                    <td className="px-2 py-1 text-gray-700">{item.etapa}</td>
                                    <td className="px-2 py-1 relative text-center">
                                        <button
                                            onClick={() => toggleMenu(item._id)}
                                            className="p-2 rounded-full text-gray-600 hover:bg-gray-100 transition"
                                        >
                                            <FaEllipsisH />
                                        </button>
                                        {activeMenu === item._id && (
                                            <div className="menu-dropdown absolute z-10 right-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded transition-transform duration-150 transform text-center">
                                                <button
                                                    onClick={() => abrirModal(item)}
                                                    className="text-gray-700 px-4 py-2 hover:bg-gray-100 w-full text-center"
                                                >
                                                    Ver Detalhes
                                                </button>        
                                                {item.etapa === 'Encerramento Financeiro' && (
                                                    <button
                                                        onClick={() => handleEncerrarProjeto(item)}
                                                        className="text-red-700 px-4 py-2 hover:bg-red-100 w-full text-center"
                                                    >
                                                        Encerrar Projeto
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <ModalNegociacao negociacao={negociacaoSelecionada} onClose={fecharModal} />

            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-20">
                    <div className="bg-white p-6 rounded shadow-lg">
                        <h2 className="text-lg font-semibold mb-4">Confirmar Encerrar Projeto</h2>
                        <p className="mb-6">Tem certeza de que deseja encerrar o projeto?</p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded shadow hover:bg-gray-400 transition"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={confirmarEncerrarProjeto}
                                className="px-4 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600 transition"
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showVoltarModal && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-20">
                    <div className="bg-white p-6 rounded shadow-lg max-w-lg w-full">
                        <h2 className="text-lg font-semibold mb-4">Voltar Etapa</h2>
                        <textarea
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none mb-4"
                            rows="4"
                            placeholder="Adicione uma observação antes de voltar a etapa..."
                            value={observacaoVoltar}
                            onChange={(e) => setObservacaoVoltar(e.target.value)}
                        ></textarea>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setShowVoltarModal(false)}
                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded shadow hover:bg-gray-400 transition"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={confirmarVoltarEtapa}
                                className="px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600 transition"
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ControleProjetosFinanceiro;
